import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 15px;

  > * {
    margin: 0 7px;
  }
`
